<template>
    <div
        class="bullet"
        :class="{ positive: value === true && positive, negative: value === false && !positive }"
        @click="changeHandler"
    >
    </div>
</template>

<script>
export default {
    name: "Bullet",

    props: {
        value: {
            type: Boolean,
            default: null,
        },
        positive: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        changeHandler() {
            let emitValue = null;
            if (this.positive) {
                emitValue =  this.value === true ? null : true;
            } else {
                emitValue = this.value === false ? null : false;
            }
            this.$emit('change', emitValue);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.bullet {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 1px solid #98A0A9;
    background: #FFFFFF no-repeat center/contain;
    cursor: pointer;

    @include on-xs {
        width: 32px;
        height: 32px;
    }

    &.positive {
        border-color: #1AB2D3;
        background-color: #1AB2D3;
        background-image: url("~@/assets/images/account-track/icon/competences/apply-true.svg");
    }

    &.negative {
        border-color: #EF627D;
        background-color: #EF627D;
        background-image: url("~@/assets/images/account-track/icon/competences/apply-false.svg");
    }
}
</style>